import { render, staticRenderFns } from "./MyAssets.vue?vue&type=template&id=ded7f058&scoped=true"
import script from "./MyAssets.vue?vue&type=script&lang=js"
export * from "./MyAssets.vue?vue&type=script&lang=js"
import style0 from "./MyAssets.vue?vue&type=style&index=0&id=ded7f058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded7f058",
  null
  
)

export default component.exports